module.exports = __webpack_public_path__ + "img/face-grin-tongue-wink.4aec98ed.svg";